import { Grid, Link, withStyles } from "@material-ui/core";
import React from "react";
import GetAppIcon from "@material-ui/icons/GetApp";
import { FF1Colors } from "../../themes/global-colors";

const styles = theme => ({
    downloadButton: {
        background: 'transparent',
        fontSize: 10,
        color: FF1Colors.darkGray,

        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        marginLeft: 10,
        marginBottom: 10,

        '&:hover': {
            background: 'transparent',
        },
        '& svg': {
            marginRight: 5,
            width: '.8em',
            height: '.8em',
            [theme.breakpoints.down('sm')]: {
                width: '.6em',
                height: '.6em',
            },
        }
    },
});

const CustomerDocumentsDownload = ({ classes }) => {

    const getPdfUrl = (systemDocumentType) => {
        return `${process.env.REACT_APP_API_HOST || ''}/publicapi/download/customer/document/${systemDocumentType}`;
    }

    return (
        <Grid container alignItems='center' justify='center' >

            <Grid item >

                <Link className={classes.downloadButton} href={getPdfUrl('NOTES_ON_DATA_PROCESSING')} target='_blank'>
                    <GetAppIcon />
                    Hinweise zur Datenverarbeitung
                </Link >
            </Grid>

            <Grid item >
                <Link className={classes.downloadButton} href={getPdfUrl('CANCELLATION_POLICY')} target='_blank'>
                    <GetAppIcon />
                    Widerrufsrecht
                </Link >

            </Grid>
            <Grid item >
                <Link className={classes.downloadButton} href={getPdfUrl('CUSTOMER_INFORMATION')} target='_blank'>
                    <GetAppIcon />
                    Kundeninformationen
                </Link >

            </Grid>
            <Grid item >
                <Link className={classes.downloadButton} href={getPdfUrl('AGB')} target='_blank'>
                    <GetAppIcon />
                    AGBs
                </Link >

            </Grid>

        </Grid>
    );

};

export default withStyles(styles)(CustomerDocumentsDownload);